import { History } from "../../../../../common/svg/History";
import { TagGroup } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { handleTagClickOutside } from "../../../../../common/utils/handleTagClickOutside";
import { getValidityPeriodDisplay } from "../../../../../common/utils/getValidityPeriodDisplay";
import { FunctionGroupInterface } from "../../../../../common/interfaces/FunctionGroupInterface";
import { QualificationStandardsInterface } from "../../../../../common/interfaces/QualificationStandardsInterface";
import { ValidityPeriodIconEnum } from "../../../../../common/enums/ValidityPeriodIconEnum";
import { InfiniteImage } from "../../../../../common/svg/InfiniteImage";
import {
    setFormStep,
    setIsFunctionGroupModalOpen,
    setIsQualificationStandardModalOpen,
} from "../../../CreateCertificateModalSlice";

export const CreateFormHeader = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const functionGroupModalRef = useRef<HTMLDivElement>(null);
    const qualificationStandardModalRef = useRef<HTMLDivElement>(null);
    const {
        selectedEmployees,
        formStep,
        selectedQualification,
        isFunctionGroupModalOpen,
        isQualificationStandardModalOpen,
    } = useAppSelector((state) => state.createCertificateModal);

    useEffect(() => {
        const clickOutsideHandler = (event: MouseEvent): void => {
            handleTagClickOutside({
                functionGroupModalRef,
                qualificationStandardModalRef,
                isFunctionGroupModalOpen,
                isQualificationStandardModalOpen,
                setIsFunctionGroupModalOpen,
                setIsQualificationStandardModalOpen,
                dispatch,
                event,
            });
        };

        document.addEventListener("mousedown", clickOutsideHandler);

        return () => {
            document.removeEventListener("mousedown", clickOutsideHandler);
        };
    }, [isFunctionGroupModalOpen, isQualificationStandardModalOpen, dispatch]);

    if (!selectedQualification) {
        return null;
    }

    const validityPeriod = getValidityPeriodDisplay({
        validityPeriod: selectedQualification.validity_period,
        validityType: selectedQualification.validity_type,
        fixedValidUntil: selectedQualification.fixed_valid_until,
    });

    return (
        <div className={"c-create-certificates-modal__header"}>
            <div className={"c-create-certificates-modal__header__tags"}>
                {selectedQualification?.function_group.length > 0 && (
                    <TagGroup
                        tags={selectedQualification?.function_group.map(
                            (tag: FunctionGroupInterface) => ({
                                id: tag.id,
                                name: tag.name,
                            }),
                        )}
                        tagColor={"#1D2D58"}
                        tagBackgroundColor={"#DAEBA8"}
                        isOpen={isFunctionGroupModalOpen}
                        handleClick={() =>
                            dispatch(
                                setIsFunctionGroupModalOpen(
                                    !isFunctionGroupModalOpen,
                                ),
                            )
                        }
                        modalRef={functionGroupModalRef}
                    />
                )}
                {selectedQualification?.qualification_standards.length > 0 && (
                    <TagGroup
                        tags={selectedQualification?.qualification_standards.map(
                            (tag: QualificationStandardsInterface) => ({
                                id: tag.id,
                                name: tag.tag,
                            }),
                        )}
                        tagColor={"#FFFFFF"}
                        tagBackgroundColor={"#07A9D6"}
                        isOpen={isQualificationStandardModalOpen}
                        handleClick={() =>
                            dispatch(
                                setIsQualificationStandardModalOpen(
                                    !isQualificationStandardModalOpen,
                                ),
                            )
                        }
                        modalRef={qualificationStandardModalRef}
                    />
                )}
                {validityPeriod && (
                    <div
                        className={
                            "c-create-certificates-modal__header__tags__expiry-date"
                        }
                    >
                        {validityPeriod.icon ===
                        ValidityPeriodIconEnum.INFINITE ? (
                            <InfiniteImage />
                        ) : (
                            <History />
                        )}
                        <p>{validityPeriod.text}</p>
                    </div>
                )}
            </div>
            <div className={"c-create-certificates-modal__header__steps"}>
                <button
                    type="button"
                    className={`c-create-certificates-modal__header__steps__step ${formStep === 1 ? "c-create-certificates-modal__header__steps__step--active" : "c-create-certificates-modal__header__steps__step--inactive"}`}
                    onClick={() => dispatch(setFormStep(1))}
                >
                    <p>1. Selecteer medewerker(s)</p>
                </button>
                <button
                    type="button"
                    className={`c-create-certificates-modal__header__steps__step ${formStep === 2 ? "c-create-certificates-modal__header__steps__step--active" : "c-create-certificates-modal__header__steps__step--inactive"}`}
                    onClick={() => {
                        if (selectedEmployees.length > 0) {
                            dispatch(setFormStep(2));
                        }
                    }}
                >
                    <p>2. Datum behaald & documenten</p>
                </button>
            </div>
        </div>
    );
};
